<template>
  <b-row class="no-gutters ml-n3">
    <b-col class="col-12 col-md-4 col-lg-4 pl-3">
      <search-input
        v-model="searchInput"
        label="search"
        :placeholder="$t('condominiumName')"
        @search="search"
      ></search-input>
    </b-col>
    <b-col v-if="$_authUserIsDomi" class="col-12 col-md-4 col-lg-4 pl-3">
      <form-select v-model="filterCondominiumStatus" label="status">
        <b-form-select-option :value="null">
          {{ $t("all") }}
        </b-form-select-option>
        <b-form-select-option
          v-for="(status, index) in condominiumStatusOptions"
          :key="index"
          :value="status.value"
        >
          <span class="text-capitalize">{{ status.label }}</span>
        </b-form-select-option>
      </form-select>
    </b-col>
  </b-row>
</template>

<script>
import authMixin from "./../../mixins/authMixin";

import SearchInput from "../Base/BaseSearchInput";
import FormSelect from "../Base/BaseFormSelect";
export default {
  components: {
    SearchInput,
    FormSelect
  },
  mixins: [authMixin],
  data() {
    return {
      searchInput: "",
      condominiumStatusOptions: [
        { label: this.$t("active"), value: "pro" },
        { label: this.$t("toActivate"), value: "pro-hold" },
        { label: this.$t("freeCondominium"), value: "free" }
      ]
    };
  },
  mounted() {
    this.searchInput = this.filterSearch;
  },
  computed: {
    filterSearch: {
      get() {
        return this.$store.getters["condominium/getFilterSearch"];
      },
      set(value) {
        this.$store.commit("condominium/SET_FILTER_SEARCH", value);
      }
    },
    filterCondominiumStatus: {
      get() {
        return this.$store.getters["condominium/getFilterCondominiumStatus"];
      },
      set(value) {
        this.$store.commit("condominium/SET_FILTER_CONDOMINIUM_STATUS", value);
        this.retrieveCondominiums();
      }
    }
  },
  methods: {
    getAdministratorName(profile) {
      if (profile && profile.name && profile.surname)
        return `${profile.name} ${profile.surname}`;
      else return "";
    },
    search() {
      this.filterSearch = this.searchInput;
      this.retrieveCondominiums();
    },
    async retrieveCondominiums() {
      try {
        this.$store.commit("loader/SET_LOADER", {});
        await this.$store.dispatch("condominium/retrieveCondominiumsByFilters");
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    }
  }
};
</script>

<style lang="scss"></style>
